export const getImage = (src, providerConfig, config) => {
  const { nuxtContext } = config
  const { $image } = nuxtContext
  return $image.ms.getImage(src, providerConfig, config)
}
